<template>
  <div>
      <v-container fluid>
       <v-layout row wrap>
         <v-flex xs12>
            <v-text-field label="บ้านเลขที่" v-model="address.addressNo"></v-text-field>
         </v-flex>
       </v-layout>
       <v-layout row wrap>
         <v-flex xs12 md6>
            <v-select
              label="จังหวัด"
              :items="provinceItems"
              v-model="address.province"
              item-value="id"
              item-text="tname"
              :disabled="disabled"
              @input="onChangeProvince"
              return-object
            ></v-select>
         </v-flex>
         <v-flex xs12 md6>
            <v-select
              :items="districtItems"
              v-model="address.district"
              label="อำเภอ"
              item-value="id"
              item-text="tname"
              :disabled="disabled"
              @input="onChangeDistrict"
              return-object
          ></v-select>
         </v-flex>
       </v-layout>
       <v-layout row wrap>
         <v-flex xs12 md6>
            <v-select
              :items="tambonItems"
              v-model="address.tambon"
              label="ตำบล"
              item-value="id"
              item-text="tname"
              :disabled="disabled"
              @input="onChangeTambon"
              return-object
            ></v-select>
         </v-flex>
         <v-flex xs12 md6>
            <v-text-field label="รหัสไปรษณีย์" v-model="address.zipcode"
              mask="#####" class="mt-0 mb-0"></v-text-field>
         </v-flex>
       </v-layout>
       <v-layout row wrap>
         <v-flex xs12 md6>
            <v-text-field label="โทรศัพท์" mask="phone"
              v-model="address.phone" class="mt-0 mb-0" :disabled="disabled"></v-text-field>
         </v-flex>
         <v-flex xs12 md6>
            <v-text-field label="โทรสาร" mask="phone" v-model="address.fax"
              class="mt-0 mb-0" :disabled="disabled"></v-text-field>
         </v-flex>
       </v-layout>
      </v-container>
    <v-snackbar :timeout="3000" :top="true" v-model="snackbar">{{ snackbarText }}</v-snackbar>
  </div>
</template>

<script>
import config from '@/config/index'
import { mapGetters } from 'vuex'

export default {
  props: {
    address: {
      type: Object,
      default: {
        province: {
          id: null
        },
        district: {
          id: null
        },
        tambon: {
          id: null
        },
        zipcode: ''
      }
    },
    disabled: { default: false, type: Boolean}
  },
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      districtItems: [],
      tambonItems: []
    }
  },
  computed: {
    provinceItems() {
      return this.$store.getters['address/provinceItems']
    }
  },
  mounted() {
    this.$store.dispatch('address/fetchProvinces')
    .then(()=>{
      if(this.address.province && this.address.province.id){
        this.districtItems = this.$store.getters['address/districtItems'](this.address.province.id)
      }
      if(this.address.district && this.address.district.id){
        this.tambonItems = this.$store.getters['address/tambonItems'](this.address.district.id)
      }
    })
  },
  methods: {
    refresh(){
      if(this.address.province && this.address.province.id){
        this.onChangeProvince(this.address.province.id)
        if(this.address.district && this.address.district.id){
          this.onChangeDistrict(this.address.district.id)
        }
      }
    },
    onChangeProvince(val){
      if(val != undefined && val != null){
        if(typeof val === 'object') val = val.id
        this.districtItems = this.$store.getters['address/districtItems'](val)
      }
    },
    onChangeDistrict(val) {
      if(val != undefined && val != null){
        if(typeof val === 'object') val = val.id
        this.tambonItems = this.$store.getters['address/tambonItems'](val)
      }
    },
    onChangeTambon(val) {
      if(val != undefined && val != null){
        if(typeof val === 'object') val = val.id
        let found = this.tambonItems.find( ele => ele.id === val )
        if(found) this.address.zipcode = found.zipcode
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/address/index.vue